import React, { useState } from 'react';
import RatingStars from './RatingStars';
import no_picture from '../images/no-profile-picture.png';
import rising_star from '../../src/icons/rising-star.svg';
import { HeartIcon } from '@heroicons/react/20/solid';
import { generateInitials } from './Utils';
export default function ProviderProfileMobile({ provider, type = 'single', readonly = false }) {
  const [ratingValue, setRatingValue] = useState(provider?.rating);
  const handleRating = () => {
    setRatingValue(rate);
  };
  return (
    <div className={'mb-2 ml-5 ' + (type === 'single' ? ' flex ' : ' flex ')}>
      <div className={'ml-4 flex ' + (type === 'single' ? 'w-1/2 justify-end' : '  w-[120px]')}>
        {provider?.profile_image ? (
          <img
            className={' h-[70px] w-[70px] rounded-full ' + (type === 'single' ? 'mr-4' : '')}
            src={provider?.profile_image ? provider?.profile_image.absolute_url : no_picture}
            alt={provider?.first_name}
          />
        ) : (
          <div className='mb-4 h-[70px] w-[70px] rounded-full bg-[#FD56AD] p-2'>
            <span className='flex h-full w-full items-center justify-center text-3xl font-bold text-white'>
              {generateInitials(provider?.first_name + ' ' + provider?.last_name)}
            </span>
          </div>
        )}
      </div>
      <div className='w-full'>
        <div className='flex'>
          <div className='flex grow flex-col'>
            <div className={'text-client-text font-medium'}>
              {provider?.first_name} {provider?.last_name}
            </div>
            <div className={'text-client-text flex text-sm' + (!provider?.isPreferred && ' hidden')}>
              {provider?.isPreferred && <HeartIcon className='text-client-text mr-1 h-5 w-5' />} Preferred Provider
            </div>
          </div>
        </div>
        <div className='flex flex-col'>
          {provider?.delivered_orders == 1 ? (
            <div className='text-client-text text-sm'>{provider?.delivered_orders} Order Delivered</div>
          ) : provider?.delivered_orders > 1 ? (
            <div className='text-client-text text-sm'>{provider?.delivered_orders} Orders Delivered</div>
          ) : (
            <div className='text-client-text mb-1 flex'>
              <img src={rising_star} alt='tick' className='mr-2 h-5 w-5' />
              <span>Rising Talent</span>
            </div>
          )}
          {provider?.average_ratings > 0 && provider?.delivered_orders > 0 ? (
            <div className='flex'>
              <RatingStars onClick={() => handleRating} ratingValue={provider?.average_ratings} readonly={readonly} />
            </div>
          ) : provider?.average_ratings == 0 && provider?.delivered_orders > 0 ? (
            <div className='text-client-text mb-1 text-sm'>Be the first to Review</div>
          ) : (
            <div className='text-client-text mb-1 text-sm'>Ready for Deliveries</div>
          )}
        </div>
      </div>
    </div>
  );
}
